import React, { useState } from "react";
import TabbedViewWithDateSelect from "../../components/TabbedViewWithDateSelect/TabbedViewWithDateSelect";
import AsnOverviewReport from "../../components/AsnOverviewReport/AsnOverviewReport";
import styles from "./AsnOverviewReportView.module.css";

const AsnOverviewReportView = () => {
  const [AsnOverviewCount, setAsnOverviewCount] = useState(0);

  const title = "AsnOverview Report";

  return (
    <div>
      <div className={styles.TabbedViewWithDateSelect}>
      <TabbedViewWithDateSelect
        tabs={[
          {
            label: "AsnOverview Report",
            title: "AsnOverview Report",
            count: AsnOverviewCount,
            countColor:  'blue',
            backgroundColor: 'blue',
            component: AsnOverviewReport,
            props: {
              handleCountChange: setAsnOverviewCount,
            },
          },
        ]}
        pageTitle={title}
      />
      </div>
    </div>
  );
};

export default AsnOverviewReportView;
